import { useEffect } from 'react';
import { i18nActions, useI18nStore } from '../store';

const { FETCH_TIMEZONES } = i18nActions;

export const useFetchTimeZones = () => {
  const language = useI18nStore('language');

  useEffect(() => {
    FETCH_TIMEZONES();
  }, [language]);
};
